/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { defaultToEmptyString, twoDigits } from '../../assets/ts/formatting/formatting'
import { getFilteredDates } from '../../assets/ts/general/general'
import { MetadataContext } from '../../store/metadata-context-provider'
import { UserContext } from '../../store/user-context-provider'
import CustomSelect from '../../utils/controls/custom-select'
import { Dates, FilterBy } from '../../utils/controls/select-options-data'
import ActionButtons from '../buttons/action-buttons'
import Tabs from '../tabs/tabs'
import NotificationTabContent from './notification-tab-content'
import './notifications.css'

let popupTop: number
let xpositionvalue: any
let offsetLeftValue: number
let offsetTopValue: number
let elementHeightValue: number
let offsetWidthValue: number

const Notifications = () => {
  const { sections } = useContext(MetadataContext)
  const [selectedTab, setSelectedTab] = useState(0)
  const [notificationData, setNotificationData] = useState<any[]>([])
  const [filterInputs, setFilterInputs] = useState({
    date: '',
    read: 'All',
  })
  const [filteredNotificationData, setFilteredNotificationData] = useState<any[]>([])
  const {me, multiplePopup, setMultiplePopup } = useContext(UserContext)

  function onChangeFilterBy(value: any) {
    setFilterInputs({
      ...filterInputs,
      read: value.value,
    })
    return
  }
  function onChangeDate(value: any) {
    setFilterInputs({
      ...filterInputs,
      date: value.value,
    })
    return
  }
  const location = useLocation()
  useEffect(() => {
    if (me?.userId && sections.length > 0 && location) {
      handleNotifications()
    }
  }, [me, sections, location])

  useEffect(() => {
    if (!multiplePopup) {
      setSelectedTab(0)
      setFilterInputs({
        date: 'All',
        read: 'All',
      })
    }
  }, [multiplePopup])

  useEffect(() => {
    const filteredNotifications = notificationData.filter((notification) => {
      const containsDate = getFilteredDates(filterInputs.date)

      return (
        (filterInputs.read === 'All' ||
          (filterInputs.read === 'Read' && notification.IsRead) ||
          (filterInputs.read === 'Unread' && !notification.IsRead)) &&
        ((filterInputs.date === 'More than 15 days' && containsDate > notification.ItemCreated) ||
          (filterInputs.date !== 'More than 15 days' && containsDate < notification.ItemCreated))
      )
    })
    setFilteredNotificationData(filteredNotifications.sort((a, b) =>
      new Date(b.ItemCreated).getTime() - new Date(a.ItemCreated).getTime()
    ))
  }, [filterInputs, notificationData])

  const handleNotifications = async () => {
    const list: any = await mpfRListsHttp().getList('NotificationsList')

    const notifications: any[] = await list
      .query()
      .select(
        'eKey',
        'eTag',
        'AlertText',
        'DataID',
        'DataGUID',
        'IsDueOut',
        'IsRead',
        'AlertType',
        'ItemCreatedBy',
        'ItemCreatedBy/firstname',
        'ItemCreatedBy/lastname',
        'ItemCreated',
        'To',
        'ReadArray'
      )
      .expand('ItemCreatedBy')
      .get()

    const filteredNotificationsData = notifications.filter((notification) => {
      let roleIncluded = false
      const sectionShortName = sections.find(
        (section) => section.Section === notification.To.split('-')[1]
      )?.ShortName
      me.roles.forEach((role) => {
        if (
          role.includes(`${notification.To.split(' ')[0]} FSS-MPF`) &&
          role.includes(`${notification.To.split('-')[2]}`) &&
          role.includes(sectionShortName)
        ) {
          roleIncluded = true
        }
      })

      return notification.To.includes(me.userId) || roleIncluded
    })

    const formattedNotifications = filteredNotificationsData.map((notification) => {
      let isRead = notification.IsRead

      if (notification.ReadArray && notification.ReadArray.includes(me.userId)) isRead = true

      return {
        ...notification,
        IsRead: isRead,
      }
    })

    setNotificationData(formattedNotifications)
  }

  const [notificationItems, setNotificationItems] = useState<any[]>([
    {
      content: (
        <div className='max-h-200 overflow-auto pe-1'>
          <NotificationTabContent
            handleNotifications={handleNotifications}
            me={me}
            notifications={filteredNotificationData}
            setMultiplePopup={setMultiplePopup}
          />
        </div>
      ),
      count: defaultToEmptyString(twoDigits(filteredNotificationData.length) || 0),
      isActive: selectedTab === 0,
      tabTitle: 'ALL',
    },
    {
      content: (
        <div className='max-h-200 overflow-auto pe-1'>
          <NotificationTabContent
            handleNotifications={handleNotifications}
            me={me}
            notifications={filteredNotificationData.filter((noti) => noti.AlertType === 'ACTION')}
            setMultiplePopup={setMultiplePopup}
          />
        </div>
      ),
      count: defaultToEmptyString(
        twoDigits(
          filteredNotificationData.filter((noti) => noti.AlertType === 'ACTION')
            .length
        ) || defaultToEmptyString(0)
      ),
      isActive: selectedTab === 1,
      tabTitle: 'Actions',
    },
    {
      content: (
        <div className='max-h-200 overflow-auto pe-1'>
          <NotificationTabContent
            handleNotifications={handleNotifications}
            me={me}
            notifications={filteredNotificationData.filter(
              (noti) => noti.AlertType === 'NOTIFICATION'
            )}
            setMultiplePopup={setMultiplePopup}
          />
        </div>
      ),
      count: defaultToEmptyString(
        twoDigits(
          filteredNotificationData.filter(
            (noti) => noti.AlertType === 'NOTIFICATION'
          ).length
        ) || 0
      ),
      isActive: selectedTab === 2,
      tabTitle: 'Notifications',
    },
  ])

  useEffect(() => {
    setNotificationItems([
      {
        content: (
          <div className='max-h-200 overflow-auto pe-1'>
            <NotificationTabContent
              handleNotifications={handleNotifications}
              me={me}
              notifications={filteredNotificationData}
              setMultiplePopup={setMultiplePopup}
            />
          </div>
        ),
        count: defaultToEmptyString(twoDigits(filteredNotificationData.length) || 0),
        isActive: selectedTab === 0,
        tabTitle: 'ALL',
      },
      {
        content: (
          <div className='max-h-200 overflow-auto pe-1'>
            <NotificationTabContent
              handleNotifications={handleNotifications}
              me={me}
              notifications={filteredNotificationData.filter((noti) => noti.AlertType === 'ACTION')}
              setMultiplePopup={setMultiplePopup}
            />
          </div>
        ),
        count: defaultToEmptyString(
          twoDigits(
            filteredNotificationData.filter((noti) => noti.AlertType === 'ACTION')
              .length
          ) || defaultToEmptyString(0)
        ),
        isActive: selectedTab === 1,
        tabTitle: 'Actions',
      },
      {
        content: (
          <div className='max-h-200 overflow-auto pe-1'>
            <NotificationTabContent
              handleNotifications={handleNotifications}
              me={me}
              notifications={filteredNotificationData.filter(
                (noti) => noti.AlertType === 'NOTIFICATION'
              )}
              setMultiplePopup={setMultiplePopup}
            />
          </div>
        ),
        count: defaultToEmptyString(
          twoDigits(
            filteredNotificationData.filter(
              (noti) => noti.AlertType === 'NOTIFICATION'
            ).length
          ) || 0
        ),
        isActive: selectedTab === 2,
        tabTitle: 'Notifications',
      },
    ])
  }, [filteredNotificationData, filterInputs, selectedTab])

  /** *** Responsive Popup Code Start*****/
  const notification = useRef(null)
  const popupbtnRef = useRef(null)
  const [xpositionvalueupdate, setpopupwidthupdate] = useState('')
  const [popupheight, setpopupheight] = useState<any>()
  const [showActionPopups, setShowActionPopups] = useState({
    notification: false,
  })
  const [btnActionshowhide, setActionbtnshowhide] = useState({
    notification: false,
  })

  const markAllAsRead = async () => {
    const list: any = await mpfRListsHttp().getList('NotificationsList')
    const promiseArr: any[] = []
    notificationData.filter((noti) => noti.AlertType === 'NOTIFICATION').map((notification) => {
      promiseArr.push(list
        .addOrUpdateItem({
          ...notification,
          IsRead: true,
        }).catch((error) => {
          console.error('Error marking notification as read:', error)
        })
      )
      return {
        ...notification,
        IsRead: true,
      }
    })

    await Promise.all(promiseArr)
    handleNotifications()
  }

  useEffect(() => {
    setpopupheight(window.innerHeight - (offsetTopValue + 90))
    const popupwidthdata = popupbtnRef.current ? popupbtnRef.current.offsetWidth : 0
    // setpopupwidth(popupwidthdata)
    if (popupwidthdata < xpositionvalue) {
      xpositionvalue = xpositionvalue - popupwidthdata
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = offsetLeftValue
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = 0
      setpopupwidthupdate(xpositionvalue)
    }
  }, [multiplePopup])
  const showhide = { ...btnActionshowhide }
  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xposition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xpositionvalue = xposition
    offsetLeftValue = left
    offsetTopValue = top
    elementHeightValue = elementHeight
    offsetWidthValue = offsetWidth
    showhide.notification = false
    setActionbtnshowhide(showhide)
    if (type === multiplePopup) {
      setMultiplePopup()
    } else if (type) {
      setMultiplePopup(type)
    }
  }
  return (
    <div className='notification p-relative'>
      <ActionButtons
        badge='badge bgcolor-primary border-radius3 px-1 font-10 whitetext'
        badgeInfo={filterInputs.read === 'Read' ? defaultToEmptyString(twoDigits(0) || 0
        ).toString() : defaultToEmptyString(twoDigits(
          notificationData.filter((noti) => !noti.IsRead).length) || 0
        ).toString()}
        className={
          multiplePopup === 'notification'
            ? 'btn btn-sm p-0 p-relative popup-arrow me-2'
            : 'btn btn-sm p-0 p-relative me-2'
        }
        icon='icon-bell font-24 title-color43'
        isClick='notification'
        label='Notifications'
        name=''
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        ref={notification}
        showHide={showActionPopups.notification}
        type='button'
      />
      {multiplePopup === 'notification' ? (
        <div
          className='popup p-0'
          ref={popupbtnRef}
          style={{
            maxHeight: popupheight,
            overflow: 'auto',
            position: 'absolute',
            top: popupTop + 8,
          }}
        >
          <div className='d-flex w-100 p-relative align-items-center border-bottom1 py-2 px-3'>
            {/* {selectedTab === 2 && <div className='mark-all-as-read' onClick={markAllAsRead} title='Mark All as Read'>Mark All as Read</div>} */}
            <h2
              aria-label='Alerts'
              className='d-flex align-items-center font-12 text-uppercase Poppins-SemiBold title-color49 pt-3'
              tabIndex={0}
            >
              <span className='icon-bell font-16 pe-1'></span> Alerts
            </h2>
            <div className='d-flex align-sm-items-end align-items-center  ms-auto pt-3 flex-wrap'>
              <div className='d-flex align-items-center ms-1 flex-sm-wrap'>
                <div className='mx-2'>
                  <CustomSelect
                    className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                    formClassName='form-horizontal  dash poppins-semibold font-11'
                    id='FilterBy'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color',
                    }}
                    label='Filter By'
                    name='Filter By'
                    onChange={onChangeFilterBy}
                    options={FilterBy}
                    value={filterInputs.read}
                  />
                </div>
                <div className='mx-2'>
                  <CustomSelect
                    className='form-sm w-100 max-w-sm-80 min-w-sm-80 sourcesanspro font-13 customselect'
                    formClassName='form-horizontal dash poppins-semibold font-11'
                    id='Date'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color',
                    }}
                    label='Date'
                    name='Date'
                    onChange={onChangeDate}
                    options={Dates}
                    value={filterInputs.date}
                  />
                </div>
              </div>

              <div className='font-12 poppins-medium title-color ms-1 ms-auto'>days</div>
            </div>
            <div className='close'>
              <ActionButtons
                className='my-0 btn font-0'
                icon='icon-close font-10 p-1 color-primary '
                isClick='notification'
                label='close'
                name=''
                popupCloseOpenFunctionality={popupCloseOpenFunctionality}
                ref={notification}
                showHide={showActionPopups.notification}
                type='button'
              />
            </div>
          </div>
          <div className='py-2 px-3'>
            <Tabs
              anchorclass='title-color2 font-12 poppins-medium text-capitalize '
              badge='badge font-12 border-radius3 px-2 py-1 whitetext'
              className='title-color2 lg'
              isButtons={selectedTab === 2 && <div className='mark-all-as-read' onClick={markAllAsRead} tabIndex={0} title='Mark All As Read'>Mark All As Read</div>}
              items={notificationItems}
              onTabSelected={(e) => setSelectedTab(e)}
              tablistclassName='overflow-auto text-capitalize '
            />
          </div>
          <div className='p-2 bgcolor-62 text-center d-none'>
            <Link
              className='font-12 poppins-semibold title-color44'
              title='See all Notifications'
              to='#'
            >
              See all Notifications
            </Link>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
export default Notifications
